import { store } from '@/state/store';
import { local_workspace_child_entity_child_viewer_delete } from '@/state/workspace/child_entity/local_workspace_child_entity_child_viewer_delete';
import { local_workspace_child_entity_child_viewer_upsert } from '@/state/workspace/child_entity/local_workspace_child_entity_child_viewer_update_status';
import { DTOWorkspaceChildEntityViewer } from '@shared/dto/+workspace/workspace_entity/dto_workspace_child_entity_viewer';
import { ENUM__network_event_server_to_client as ENE } from '@shared/network/ENUM__network_event_server_to_client';
import { add_socket_handler_client as add } from '../../_methods/add_socket_handler_client';

export function add_socket_handlers_client_workspace_child_entity() {
  add(ENE.WORKSPACE_CHILD_ENTITY_VIEWER_UPSERT, (items: DTOWorkspaceChildEntityViewer[]) => {
    store.dispatch(local_workspace_child_entity_child_viewer_upsert(items));
  });

  add(ENE.WORKSPACE_CHILD_ENTITY_VIEWER_DELETE, (ids: string[]) => store.dispatch(local_workspace_child_entity_child_viewer_delete(ids)));
}
